module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAL9JREFUSA3tVdsNwyAMDNAxkoGyCBUTobJIB0rXAGoqWTKImJSkX4UfwBznx/GYph83QfmNMav33oFtpvbW2DmX8VC8pJMecrq/Nr4Vxk/kXEQFvjnNMmiiOwBlBhlFjyZCiE1KebfWPhMZm0GPJjHGJYTwwEjZDAD0tSZaa/ARF3TAZoCgM/1w0KzeKNEflCi7yVe+oli7cYqwErt9pkEF9QLbnF7IytquKf0JuMhqoJTSAExODjf8cA5vOAt8A+lBL+p9zoHyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Grey/Duplicate.png
// module id = 659
// module chunks = 0